import { render, staticRenderFns } from "./mail_limit.vue?vue&type=template&id=7db24518&scoped=true&"
import script from "./mail_limit.vue?vue&type=script&lang=js&"
export * from "./mail_limit.vue?vue&type=script&lang=js&"
import style0 from "./mail_limit.vue?vue&type=style&index=0&id=7db24518&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db24518",
  null
  
)

export default component.exports